import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=cd73a55c&scoped=true&"
import script from "./Plans.vue?vue&type=script&lang=tsx&"
export * from "./Plans.vue?vue&type=script&lang=tsx&"
import style0 from "./Plans.vue?vue&type=style&index=0&id=cd73a55c&scoped=true&lang=less&"
import style1 from "./Plans.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd73a55c",
  null
  
)

export default component.exports